import { useData } from '@hooks/useData';
import { Role } from '../types';

export const useRoleChecker = (selectedRole?: string) => {
    const { roles, login: user } = useData();

    const getUserRole = (): Role | null => {
        if (selectedRole) {
            return roles?.data.find((role: Role) => role.name?.toLowerCase() === selectedRole.toLowerCase()) || null;
        }

        const userType = user?.data?.user_type;
        if (!userType) return null;

        return roles?.data.find((role: Role) => role.name?.toLowerCase() === userType.toLowerCase()) || null;
    };

    const isDriver = getUserRole()?.name?.toLowerCase() === 'driver';

    const isRider = getUserRole()?.name?.toLowerCase() === 'rider';

    return { getUserRole, isDriver, isRider };
};
